import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconOldJoystick: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"old-joystick, gamepad, gaming, control"} maskId="square-filled-radius-0-stroke-1-IconOldJoystick"><path d="M12 3C13.933 3 15.5 4.567 15.5 6.5C15.5 8.2632 14.1961 9.72121 12.5 9.96387V15H17V12H18V15H21V21H3V15H11.5V9.96387C9.8039 9.72121 8.5 8.2632 8.5 6.5C8.5 4.567 10.067 3 12 3Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconOldJoystick;
